<template>
  <OperativeTable :dense="dense">
    <OperativeTableHeader :years="yearsTableHeadings" />
    <tbody>
    <OperativeTableBodyRow :values="yearsTableRows.ricavi">
      Ricavi
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.deltaScorte">
      ∆ Scorte
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.cogs">
      Cogs
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.grossMargin" strong>
      Gross Margin
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.marginePerc" em>
      Margine %
      <template #cell-content="{ value }">{{ value }}%</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow v-if="isModuleProjectsEnabled" :values="yearsTableRows.personale">
      Personale Indiretto
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow v-else :values="yearsTableRows.personale">
      Personale
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.ga">
      G&amp;A
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.EBITDA" strong>
      EBITDA
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.EBITDAvendite" em>
      EBITDA/Vendite
      <template #cell-content="{ value }">{{ value }}%</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.ammortamenti">
      Ammortamenti e acc.
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.EBIT" strong>
      EBIT
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.costiFinanziari">
      Costi finanziari
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.EBT" strong>
      EBT
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.contributiFondoPerduto">
      Contributi a fondo perduto
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.creditoImposta">
      Credito d'imposta
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.tasse">
      Tasse
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.risultato" strong>
      Risultato Netto
      <template #cell-content="{ value }">{{ value | money }}</template>
    </OperativeTableBodyRow>
    <OperativeTableBodyRow :values="yearsTableRows.caricoFiscale" em>
      Carico fiscale
      <template #cell-content="{ value }">{{ value }}%</template>
    </OperativeTableBodyRow>
    </tbody>
  </OperativeTable>
</template>

<script>

import computedFinancialDataMixin from '@/mixins/computedFinancialData.js';
import operativePageMixin from '@/mixins/operativePage.js';
import formatMoneyFilter from '@/filters/formatMoney.js';

export default {
  mixins: [operativePageMixin, computedFinancialDataMixin],
  components: {
    OperativeTable: () => import('@/views/components/Operative/OperativeTable.vue'),
    OperativeTableBodyRow: () => import('@/views/components/Operative/OperativeTableBodyRow.vue'),
    OperativeTableHeader: () => import('@/views/components/Operative/OperativeTableHeader.vue'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    yearsTableRows: {
      default: null,
      type: Object,
    },
    yearsTableHeadings: {
      default: null,
      type: Array,
    },
    dense: {
      default: false,
      type: Boolean,
    },
    isModuleProjectsEnabled: {
      default: false,
      type: Boolean,
    },
    isModuleSubsidizedFinanceEnabled: {
      default: false,
      type: Boolean,
    },
  },
};

</script>
